export default __webpack_public_path__ + "static/media/logo_kotelnica.c118309c.svg";